import AAEHUDFactory from "pages/AAE-HUD-Factory";
import AAEHUDFactoryFeatures from "pages/AAE-HUD-Factory-Features";
import Cart from "pages/Cart";
import Contact from "pages/Contact";
import EShop from "pages/E-Shop";
import EShopDetail from "pages/E-Shop-Detail";
import FrequentlyAskedQuestions from "pages/Frequently-Asked-Questions";
import Home from "pages/Home";
import MyDownloads from "pages/My-Downloads";
import News from "pages/News";
import ReplicaDetail from "pages/Replicas-Detail";
import ReplicaItems from "pages/Replica-Items";
import ReplicaMiscDetail from "pages/Replica-Misc-Detail";
import Replicas from "pages/Replicas";
import ReplicasFAQ from "pages/Replicas-FAQ";
import ReplicasPayment from "pages/Replicas-Payment";
import ReplicasPaymentGenerator from "pages/Replicas-Payment-Generator";
import ReplicasWIP from "pages/Replicas-WIP";
import TermsAndConditions from "pages/Terms-And-Conditions";

export type RouteType = {
  slug: string;
  page: any;
  isSubRoute?: boolean;
  anchors?: any;
};

export type RoutesType = {
  terms: RouteType;
  faq: RouteType;
  cart: RouteType;
  eshop: RouteType;
  eshopProduct: RouteType;
  myDownloads: RouteType;
  news: RouteType;
  aaeHudFactory: RouteType;
  aaeHudFactoryProduct: RouteType;
  aaeHudFactoryFeatures: RouteType;
  replicas: RouteType;
  replicasWIP: RouteType;
  replicaDetail: RouteType;
  replicaDetailVersion: RouteType;
  replicaItems: RouteType;
  replicaMiscDetail: RouteType;
  replicasFAQ: RouteType;
  replicasPayment: RouteType;
  replicasPaymentGenerator: RouteType;
  contact: RouteType;
  home: RouteType;
  unknown: RouteType;
};

export const routes: RoutesType = {
  eshop: {
    slug: "e-shop",
    page: <EShop />,
  },

  eshopProduct: {
    slug: "e-shop/:id",
    page: <EShopDetail />,
    isSubRoute: true,
  },

  terms: {
    slug: "terms",
    page: <TermsAndConditions />,
    anchors: {
      intro: "intro",
      purchaseGuide: "purchaseGuide",
      helpDesk: "helpDesk",
      license: "license",
      warrantiesAndRefunds: "warrantiesAndRefunds",
    },
  },

  faq: {
    slug: "faq",
    page: <FrequentlyAskedQuestions />,
  },

  cart: {
    slug: "cart",
    page: <Cart />,
  },

  aaeHudFactory: {
    slug: "aae-hud-factory",
    page: <AAEHUDFactory />,
    anchors: {
      intro: "intro",
      products: "products",
      productsAdditional: "productsAdditional",
      about: "about",
      demo: "demo",
    },
  },

  aaeHudFactoryProduct: {
    slug: "aae-hud-factory/:id",
    page: <EShopDetail />,
    isSubRoute: true,
  },

  aaeHudFactoryFeatures: {
    slug: "aae-hud-factory-features",
    page: <AAEHUDFactoryFeatures />,
  },

  replicas: {
    slug: "replicas",
    page: <Replicas />,
  },

  replicasWIP: {
    slug: "replicas-wip",
    page: <ReplicasWIP />,
  },

  replicaDetailVersion: {
    slug: "replicas/:id/:version",
    page: <ReplicaDetail />,
    isSubRoute: true,
  },

  replicaDetail: {
    slug: "replicas/:id",
    page: <ReplicaDetail />,
    isSubRoute: true,
  },

  replicaItems: {
    slug: "replicas-misc",
    page: <ReplicaItems />,
  },

  replicaMiscDetail: {
    slug: "replicas-misc/:id",
    page: <ReplicaMiscDetail />,
    isSubRoute: true,
  },

  replicasFAQ: {
    slug: "replicas-faq",
    page: <ReplicasFAQ />,
  },

  replicasPaymentGenerator: {
    slug: "replicas-payment-generator",
    page: <ReplicasPaymentGenerator />,
  },

  replicasPayment: {
    slug: "replicas-payment",
    page: <ReplicasPayment />,
  },

  contact: {
    slug: "contact",
    page: <Contact />,
  },

  myDownloads: {
    slug: "my-downloads",
    page: <MyDownloads />,
  },

  news: {
    slug: "news",
    page: <News />,
  },

  // 'home' HAS TO BE THE LAST!
  home: {
    slug: "",
    page: <Home />,
    anchors: {
      intro: "intro",
      replicas: "replicas",
      eshop: "e-shop",
      aaeHudFactory: "aae-hud-factory",
      about: "about",
      contact: "contact",
    },
  },

  unknown: {
    slug: null,
    page: <Home />,
  },
};
